import React, { useContext } from "react";
import {
  Area,
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { ChartContext } from "../Dashboard/Dashboard";

const VComposedChart = () => {
  const data = useContext(ChartContext);
  return (
    <div>
      <h3>Investment Vs. Revenue Vs. Sell</h3>
      <ComposedChart
        layout="vertical"
        width={450}
        height={400}
        data={data}
        margin={{
          top: 20,
          right: 20,
          bottom: 20,
          left: 20,
        }}
      >
        <CartesianGrid stroke="#f5f5f5" />
        <XAxis type="number" />
        <YAxis dataKey="month" type="category" scale="band" />
        <Tooltip />
        <Legend />
        <Area dataKey="revenue" fill="#C4E538" stroke="#A3CB38" />
        <Bar dataKey="investment" barSize={20} fill="#009432" />
        <Line dataKey="sell" stroke="#ff7300" />
      </ComposedChart>
    </div>
  );
};

export default VComposedChart;
